export default __webpack_public_path__ + "static/media/Dr Samuel Amponsah CV.511f1103.pdf";